import { errorHelpers } from '@approvalmax/utils';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

export const useIntegrationTypeDecision = () => {
    const company = useCompanyBasedOnUrl();

    const integrationType = company.integration?.integrationType;

    if (!integrationType) {
        throw errorHelpers.notSupportedError(integrationType);
    }

    return integrationType;
};
